import { create } from "zustand"
import { ITableState, TAllFilesTable } from "types/table.type"

export const useTableStore = create<ITableState>((set) => ({
	updatedTableData: [],
	setUpdatedTableData: (data) => set(() => ({ updatedTableData: data })),
}))

export const useFillesTableStore = create<TAllFilesTable>((set) => ({
	tableParams: {
		pagination: {
			current: Number(sessionStorage.getItem("pagination")) || 1,
		},
		filter: {
			owner: localStorage.getItem("owner") ?? "all",
			fileName: "",
			status: localStorage.getItem("status") ? JSON.parse(localStorage.getItem("status") || "[]") : [],
			user: localStorage.getItem("user") ?? null,
		},
	},
	setCurrentPage: (current: number) => {
		sessionStorage.setItem("pagination", current.toString())
		set((state) => ({
			tableParams: {
				...state.tableParams,
				pagination: {
					...state.tableParams.pagination,
					current,
				},
			},
		}))
	},
	setFilter: (filter) => {
		set((state) => ({
			tableParams: {
				...state.tableParams,
				filter: {
					...state.tableParams.filter,
					...filter,
				},
			},
		}))
	},
	resetSessionStoragePagination: () => {
		sessionStorage.setItem("pagination", "1")
		set((state) => ({
			tableParams: {
				...state.tableParams,
				pagination: {
					current: 1,
				},
			},
		}))
	},

	processingIds: [],
	setProcessingIds: (id) => set((state) => ({ processingIds: [...state.processingIds, id] })),
	updateProcessingIds: (newProcessingIds) => set(() => ({ processingIds: newProcessingIds })),

	duplicatingIds: [],
	setDuplicatingIds: (id) => set((state) => ({ duplicatingIds: [...state.duplicatingIds, id] })),
	removeDuplicatingId: (id) =>
		set((state) => ({ duplicatingIds: state.duplicatingIds.filter((duplicatingId) => duplicatingId !== id) })),
}))
